interface NotFoundIllustrationProps {
	color?: string
}

const NotFoundIllustration: React.FC<NotFoundIllustrationProps> = ({
	color = "currentColor",
}) => {
	return (
		<svg
			height="220px"
			viewBox="1 -37 512 511"
			width="220px"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden="true"
		>
			<path
				fill={color}
				d="M496.64.5H15.36C6.878.5 0 7.379 0 15.86v262.027h512V15.859C512 7.38 505.125.5 496.64.5zM192.517 188.023c0 8.485-6.88 15.36-15.364 15.36-8.48 0-15.359-6.875-15.359-15.36v-33.082h-40.621c-8.484 0-15.36-6.875-15.36-15.359v-46.73c0-8.485 6.876-15.36 15.36-15.36 8.48 0 15.36 6.875 15.36 15.36v31.37h25.261v-31.37c0-8.485 6.879-15.36 15.36-15.36 8.484 0 15.363 6.875 15.363 15.36zm106.836-27.992c0 23.906-19.45 43.352-43.352 43.352s-43.348-19.446-43.348-43.352v-39.187c0-23.906 19.446-43.352 43.348-43.352s43.352 19.445 43.352 43.352zm106.836 27.992c0 8.485-6.875 15.36-15.36 15.36-8.48 0-15.36-6.875-15.36-15.36v-33.082h-40.62c-8.485 0-15.364-6.875-15.364-15.359v-46.73c0-8.485 6.88-15.36 15.364-15.36 8.48 0 15.359 6.875 15.359 15.36v31.37h25.262v-31.37c0-8.485 6.879-15.36 15.36-15.36 8.483 0 15.358 6.875 15.358 15.36zm0 0"
			/>
			<path
				fill={color}
				d="M256 108.21c-6.965 0-12.633 5.665-12.633 12.63v39.191c0 6.965 5.668 12.633 12.633 12.633s12.633-5.668 12.633-12.633V120.84c0-6.965-5.668-12.63-12.633-12.63zm0 0M0 308.605v52.223c0 8.485 6.879 15.36 15.36 15.36h481.28c8.481 0 15.36-6.875 15.36-15.36v-52.223zm0 0M381.953 406.91H130.047c-8.484 0-15.36 6.875-15.36 15.36 0 8.48 6.876 15.359 15.36 15.359h251.906c8.485 0 15.36-6.879 15.36-15.36 0-8.484-6.875-15.359-15.36-15.359zm0 0"
			/>
		</svg>
	)
}

export default NotFoundIllustration
